import axios from 'axios';
import React, { useState, useEffect } from 'react'
import { FaUndo, FaMoneyCheckAlt } from 'react-icons/fa'
import { FiSearch } from 'react-icons/fi'
import { IoExitOutline } from 'react-icons/io5'
import { API_HOST } from '../../api_utils';
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from 'react-toastify'
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

function ProfitShare(props) {
  const { userDataFromStorage, coloredTheme } = props;

  const [profitShareList, setProfitShareList] = useState([])
  const [loading, setLoading] = useState(false)
  const [currentData, setCurrentData] = useState([])
  const [isPayMultiple, setIsPayMultiple] = useState(false)
  const [userList, setUserList] = useState([])
  const [currentUserList, setCurrentUserList] = useState([])
  const [paymentSuccess, setPaymentSuccess] = useState(false)


  // STATES FOR PAGINATION:
  const [page, setPage] = useState(1);
  const rowsPerPage = 5;
  const [totalPages, setTotalPages] = useState(0);

  const [page1, setPage1] = useState(1);
  const rowsPerPage1 = 5;
  const [totalPages1, setTotalPages1] = useState(0);

  const formatDate = (date) => {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    // Pad day and month with leading zeros if needed
    const formattedDay = day < 10 ? `0${day}` : day;
    const formattedMonth = month < 10 ? `0${month}` : month;

    return `${formattedDay}-${formattedMonth}-${year}`;
  };

  const [selectedDate, setSelectedDate] = useState(formatDate(new Date()));
  const [paymentSharePayload, setPaymentSharePayload] = useState({});
  const [rowsToSend, setRowsToSend] = useState([]);

  // states for filter:
  const [filterData, setFilterData] = useState([])
  const [managerName, setManagerName] = useState('')
  const [agentName, setAgentName] = useState('')




  // getManagerAPI:
  const getProfitShareListApi = async () => {
    setLoading(true);


    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${userDataFromStorage.token}`
      }
    }

    const { data } = await axios.get(`${API_HOST}/api/profit_share/`, config);
    if (data) {
      if (data.message) {
        setLoading(false)
      } else {
        setLoading(false)
        setProfitShareList(data)
        setFilterData(data)
      }
    }
  }

  // getUserListAPI:
  const getUserListCall = async () => {
    setLoading(true);
    const { userDataFromStorage } = props

    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${userDataFromStorage.token}`
      }
    }

    const { data } = await axios.get(`${API_HOST}/api/users/`, config);
    if (data) {
      if (data.message) {
        setLoading(false)
        toast.error(data.message)
      } else {
        setLoading(false)
        setUserList(data)
      }
    }
  }


  useEffect(() => {
    getProfitShareListApi()
    getUserListCall()
  }, [paymentSuccess])



  useEffect(() => {
    if (filterData.length) {
      setTotalPages(Math.ceil(filterData.length / rowsPerPage));
      const startIdx = (page - 1) * rowsPerPage;
      const endIdx = startIdx + rowsPerPage;
      const currentDataNew = filterData?.slice(startIdx, endIdx);
      setCurrentData(currentDataNew)
    }
  }, [filterData, page]);


  useEffect(() => {
    if (userList.length) {
      setTotalPages1(Math.ceil(userList.length / rowsPerPage1));
      const startIdx = (page1 - 1) * rowsPerPage1;
      const endIdx = startIdx + rowsPerPage1;
      const currentDataNew = userList?.slice(startIdx, endIdx);
      setCurrentUserList(currentDataNew)
    }
  }, [userList, page1])


  const handleAmountChange = (index, value) => {
    setPaymentSharePayload((prevState) => ({
      ...prevState,
      [index]: { ...prevState[index], amount: value }
    }));
  };

  const handleDateChange = (index, value) => {
    setPaymentSharePayload((prevState) => ({
      ...prevState,
      [index]: { ...prevState[index], date_paid: value }
    }));
  };

  const handleButtonClick = async () => {
    // Filter the rows where both fields are filled
    const rowsWithBothFieldsFilled = Object.entries(paymentSharePayload).filter(([_, value]) => value.amount && value.date_paid);

    if (rowsWithBothFieldsFilled.length > 0) {
      const paymentShareData = rowsWithBothFieldsFilled.map(([key, value]) => ({
        agent_ref: key,
        amount: value.amount,
        date_paid: value.date_paid
      }));

      // Make the POST API call with rowsToSend
      setLoading(true);
      const { userDataFromStorage } = props

      const config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${userDataFromStorage.token}`
        }
      }

      const { data } = await axios.post(`${API_HOST}/api/profit_share/add_profit_share_for_agent`, { paymentShareData }, config);
      if (data) {
        if (data[0].status === 'Payment successfully recorded') {
          console.log('data', data)
          setLoading(false)
          toast.success(data[0].status)
          setPaymentSuccess(true)
          setIsPayMultiple(false)
          paymentSharePayload({})
        } else {
          setLoading(false)
          toast.error(data[0].status)
          paymentSharePayload({})
        }
      }
    } else {
      // Handle the case when no rows have both fields filled
      setLoading(false)
      toast.warn('Please Provide A Input ')
    }
  };

  const filterCashHandler = () => {
    let filteredData1 = profitShareList.filter((user) => {
      console.log('user', user)
      if (
        (!managerName || user.manager.includes(managerName)) &&
        (!agentName || user.agent.includes(agentName)) 
        // (!agentRole || user.user_role === agentRole) &&
        // (!reportDateAfter || user.start_date > reportDateAfter) &&
        // (!reportDateBefore || user.start_date < reportDateBefore)
      ) {
        return true;
      }
      return false;

    })
    setFilterData(filteredData1)
  }


  return (
    <div className={userDataFromStorage.user_role === 'admin' ? 'xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-blue-50  overflow-hidden' : 'xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[5%] mt-[20%] bg-blue-50 overflow-hidden'}>
      <p className='text-gray-800 text-[1.8rem] tracking-wider'>Profit Share Payments</p>
      <div className='bg-white  mt-[2%]'>
        <p style={{ backgroundColor: coloredTheme }} className=' text-white px-[0.5rem] py-[1rem] '>Search Parameters</p>

        <div className='px-[0.5rem] mt-2'>
          <div className='md:flex justify-start items-center mt-6'>
            <p className='w-[25rem]'>Manager Last Name</p>
            <input value={managerName} onChange={(e)=>setManagerName(e.target.value)} type="text" className='outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0' />
          </div>
          <div className='md:flex justify-start items-center mt-6'>
            <p className='w-[25rem]'>Agent Last Name </p>
            <input value={agentName} onChange={(e)=>setAgentName(e.target.value)} type="text" className='outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0' />
          </div>
          {/* <div className='md:flex justify-start items-center mt-6'>
            <p className='w-[25rem]'>Loan Closed After</p>
            <input type="date" className='outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0' />
          </div>
          <div className='md:flex justify-start items-center mt-6'>
            <p className='w-[25rem]'>Loan Closed Before</p>
            <input type="date" className='outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0' />
          </div> */}
        </div>
        <div className='flex justify-start items-center space-x-4 p-[1rem]'>
          <button onClick={() => filterCashHandler()} style={{ backgroundColor: coloredTheme }} className='flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white'>
            <FiSearch />
            <p>Search</p>
          </button>
          <button style={{ backgroundColor: coloredTheme }} className='flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white'>
            <FaUndo />
            <p>Reset</p>
          </button>
        </div>

        {
          !isPayMultiple ?
            <div className='mt-8 bg-white pb-[1.5rem]'>
              <p style={{ backgroundColor: coloredTheme }} className='change-bg p-[1rem] md:w-[100%]  text-white'>Payments. To pay and individal agent click on any current payment to them. If they have not yet received a payment then use the Pay Multiple Agents option.</p>

              <div className='overflow-scroll px-[0.5rem]'>

                <table className='md:w-[100%] xl:w-[100%] w-[180%] '>
                  <thead className='h-[6vh]'>
                    <tr className='border border-gray-400'>
                      <th className='text-center  border-r border-gray-400 px-[0.2rem]'>Manager </th>
                      <th className='text-center  border-r border-gray-400 px-[0.2rem]'>Agent </th>
                      <th className='text-center border-r  border-gray-400 px-[0.2rem]'>Amount Paid</th>
                      <th className='text-center border-r  border-gray-400 px-[0.2rem]'>Date Paid</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      currentData.length ? currentData.map((x, index) => {
                        // convert date into dd-mm-yyyy format :
                        let date = new Date(x?.date_paid);
                        let day = String(date?.getUTCDate()).padStart(2, '0');
                        let month = String(date?.getUTCMonth() + 1).padStart(2, '0');
                        let year = String(date?.getUTCFullYear());
                        let modifiedDatePaid = `${day}-${month}-${year}`;
                        return (
                          <tr key={index} className='border border-gray-400'>
                            <td className='text-center border-l border-t border-r border-gray-400 px-[0.2rem]'>
                              {x.manager}
                            </td>
                            <td className='text-center border-l border-t border-r border-gray-400 px-[0.2rem]'>
                              {x.agent}
                            </td>
                            <td className='text-center border-l border-t border-r border-gray-400 px-[0.2rem]'>
                              {x.amount}
                            </td>
                            <td className='text-center border-t border-r border-gray-400 px-[0.2rem]'> {modifiedDatePaid}</td>
                          </tr>
                        )
                      }
                      ) : ''
                    }
                  </tbody>
                </table>
              </div>
              {/* PAGINATION */}
              <div className=' flex justify-end items-center mt-[2%] px-[0.8rem]'>
                <Stack spacing={2}>

                  <Pagination
                    count={totalPages}
                    page={page}
                    onChange={(event, newPage) => setPage(newPage)}
                    variant="outlined"
                    shape="rounded" />

                </Stack>
              </div>
              <div className='mt-6 flex justify-between items-center'>
                <button onClick={() => setIsPayMultiple(true)} style={{ backgroundColor: coloredTheme }} className='flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white'>
                  <FaMoneyCheckAlt />
                  <p>Pay Multiple Agents</p>
                </button>
                <button style={{ backgroundColor: coloredTheme }} className='flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white'>
                  <IoExitOutline />
                  <p>Exit</p>
                </button>
              </div>
            </div> :
            <div className='mt-8 bg-white pb-[1.5rem]'>
              <p style={{ backgroundColor: coloredTheme }} className='change-bg p-[1rem] md:w-[100%]  text-white'>Payment Details</p>

              <div className='overflow-scroll px-[0.5rem]'>

                <table className='md:w-[100%] xl:w-[100%] w-[180%] '>
                  <thead className='h-[6vh]'>
                    <tr className='border border-gray-400'>
                      <th className='text-center  border-r border-gray-400 px-[0.2rem]'>Manager </th>
                      <th className='text-center  border-r border-gray-400 px-[0.2rem]'>Agent </th>
                      <th className='text-center border-r  border-gray-400 px-[0.2rem]'>Payment Amount MYR</th>
                      <th className='text-center border-r  border-gray-400 px-[0.2rem]'>Date Paid</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      currentUserList.length ? currentUserList.map((x, index) => {
                        let managerCheck = userList.find((y) => y._id === x.manager);
                        if (managerCheck) {
                          return (
                            <tr key={`${index}-${page1}`} className='border border-gray-400'>
                              <td className='text-center border-l border-t border-r border-gray-400 px-[0.2rem]'>
                                {managerCheck.full_name ? managerCheck.full_name : '---'}
                              </td>
                              <td className='text-center border-l border-t border-r border-gray-400 px-[0.2rem]'>
                                {x.full_name ? x.full_name : '---'}
                              </td>
                              <td className='text-center border-l border-t border-r border-gray-400 px-[0.2rem]'>
                                <input type="number" placeholder='Enter Amount To be Paid' onChange={(e) => handleAmountChange(x._id, e.target.value)} />
                              </td>
                              <td className='text-center border-t border-r border-gray-400 px-[0.2rem]'>
                                <input
                                  type="date"
                                  id={`dateInput-${x._id}`}
                                  onChange={(e) => handleDateChange(x._id, e.target.value)}
                                  pattern="\d{2}-\d{2}-\d{4}"
                                  required
                                />
                              </td>
                            </tr>
                          )
                        }

                      }
                      ) : ''
                    }
                  </tbody>
                </table>
              </div>
              {/* PAGINATION */}
              <div className=' flex justify-end items-center mt-[2%] px-[0.8rem]'>
                <Stack spacing={2}>

                  <Pagination
                    count={totalPages1}
                    page={page1}
                    onChange={(event, newPage) => setPage1(newPage)}
                    variant="outlined"
                    shape="rounded" />

                </Stack>
              </div>
              <div className='mt-6 flex justify-between items-center'>
                <button onClick={() => handleButtonClick()} style={{ backgroundColor: coloredTheme }} className='flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white'>
                  <FaMoneyCheckAlt />
                  <p>Pay All</p>
                </button>
                <button onClick={() => setIsPayMultiple(false)} style={{ backgroundColor: coloredTheme }} className='flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white'>
                  <IoExitOutline />
                  <p>Exit</p>
                </button>
              </div>
            </div>
        }
      </div>
      <div className='mt-8 '>



      </div>

      <ToastContainer
        newestOnTop={false}
        rtl={false}
        transition={Flip}
        position="top-right"
        autoClose={2000}
        theme="dark"
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={false}
        draggable={true}
        progress={undefined}
        className="text-center"
      />

    </div>
  )
}

export default ProfitShare